module.exports = __webpack_public_path__ + "img/x5_goods_white.23100889.png";